import React, { useState } from 'react';
import { Collapse, makeStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { Col, Row } from 'react-bootstrap';
import { HealthClassOptions } from '../../../../Helpers/Lists/HealthClassOptions';
import '../PopUps.scss';

const useStyles = makeStyles((theme) => ({
    primaryColor: {
        color: theme.palette.primary.main
    }
}))

export default function HealthOptions(props) {
    const { onHide, onFieldChange } = props;
    const classes = useStyles();
    const [expandSettings, setExpandSettings] = useState([
        { id: 'uiPPInfo', isExpanded: false },
        { id: 'uiPInfo', isExpanded: false },
        { id: 'uiRPInfo', isExpanded: false },
        { id: 'uiRInfo', isExpanded: false }
    ]);

    const showHealthOption = (id) => {
        setExpandSettings((prev) => {
            return prev.map((x, i) =>
                x.id === id ? { ...x, isExpanded: !x.isExpanded } : x
            )
        })
    }

    const setHealth = (value) => {
        onFieldChange(value);
        onHide();
    }

    return (
        <div className='health-options mb-3'>
            <h4>Health Class Options</h4>
            {HealthClassOptions.map((item, i) => (
                <Row className={`p-3 ${(item.name +' '+item.subName) === props.healthClass ? 'yellow-highlight' : ''}`} key={i}>
                    <Col md={3}>
                        <h4 className={`mb-0 health-name ${classes.primaryColor}`}>{item.name}</h4>
                        <span className='health-text'>{item.subName}</span>
                    </Col>
                    <Col md={7}>
                        <p className='health-text'>{item.description}<a className={`hideShow-link button-hide ${classes.primaryColor}`} onClick={() => showHealthOption(item.id)}> {expandSettings.find((x) => x.id === item.id).isExpanded ? 'View Less' : 'View More'}</a>
                            <Collapse in={expandSettings.find((x) => x.id === item.id).isExpanded}>
                                <ul>
                                    {item.descriptionList.map((listName, i) => (
                                        <li key={i}>{listName}</li>
                                    ))}
                                </ul>
                            </Collapse>
                        </p>
                    </Col>
                    <Col md={2} className='button-hide'>
                        <Button variant='contained' color='primary' onClick={() => setHealth(item.value)}>Select</Button>
                    </Col>
                </Row>
            ))
            }
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/Product/TermLifeInsurance/PopUps/HealthClassPopUp/HealthOptions.js